interface IUserProfileConfig {
  status: {
    admin: string
    master: string
    operacional: string
  }
}
export default {
  status: {
    admin: 'ADMIN',
    master: 'MASTER',
    operacional: 'OPERACIONAL',
  },
} as IUserProfileConfig
